/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Title_1Inputs */

const en_contact_title_1 = /** @type {(inputs: Contact_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tell us what`)
};

const lv_contact_title_1 = /** @type {(inputs: Contact_Title_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pastāstiet, ko`)
};

/**
* | output |
* | --- |
* | "Tell us what" |
*
* @param {Contact_Title_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_title_1 = /** @type {((inputs?: Contact_Title_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Title_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_title_1(inputs)
	return en_contact_title_1(inputs)
});